import React from 'react';
import { Atividade, Dependencia } from '../../models/atividade';
import DependencyChain from './DependencyChain';

const VisaoCaminhoCritico: React.FC<{ atividades: Atividade[]; dependencias: Dependencia[]; onSelecionar: (id: number) => void }> = props => (
  <DependencyChain {...props} modo='critico' />
);

export default VisaoCaminhoCritico;
